var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA1SettingsSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.231 9.866l-1.331-.77a6.018 6.018 0 000-2.193l1.331-.769a.378.378 0 00.172-.437 7.783 7.783 0 00-1.71-2.956.376.376 0 00-.462-.072l-1.331.768A5.898 5.898 0 0010 2.341V.806a.374.374 0 00-.294-.365 7.856 7.856 0 00-3.412 0A.374.374 0 006 .806v1.538A6.084 6.084 0 004.1 3.44l-1.328-.77a.371.371 0 00-.463.073A7.736 7.736 0 00.6 5.7a.374.374 0 00.172.437l1.331.77a6.02 6.02 0 000 2.193l-1.331.769a.378.378 0 00-.172.437 7.783 7.783 0 001.71 2.956c.118.129.312.16.462.072l1.331-.768a5.91 5.91 0 001.9 1.096V15.2c0 .175.122.328.294.366a7.858 7.858 0 003.412 0 .374.374 0 00.294-.366v-1.538a6.082 6.082 0 001.9-1.096l1.331.768a.37.37 0 00.463-.072 7.736 7.736 0 001.71-2.956.386.386 0 00-.176-.44zM8 10.5A2.503 2.503 0 015.5 8c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z",
    fill: "#9FA2B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA1SettingsSvg);
export default __webpack_public_path__ + "static/media/a1SettingsSvg.9d9a70055c05c4fec2a98389749a100c.svg";
export { ForwardRef as ReactComponent };